import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactInfo.scss";

import ContactInfoBox from "../contactInfo/contactInfoBox";

import ContactInfoIcon1 from '../../../assets/contact/contact-info-icon1.svg';
import ContactInfoIcon2 from "../../../assets/contact/contact-info-icon2.svg";
import ContactInfoIcon3 from "../../../assets/contact/contact-info-icon3.svg";

const contactInfo = () => (
  <Row gutter={30}>  {/* Added gutter for spacing */}
    <Col xs={12}>
      <Row center="xs">
        {/* First row of 3 contact information items */}
        <Col xs={3} sm={2} className="contact__info">
          <a href="tel:+966592244021" aria-label="Call +966 5922 44021">
            <ContactInfoBox
              icon={ContactInfoIcon2}
              textLine1="+966 5922 44021"
            />
          </a>
        </Col>
        <Col xs={3} sm={2} className="contact__info">
          <a href="tel:+966578021911" aria-label="Call +966 5780 21911">
            <ContactInfoBox
              icon={ContactInfoIcon2}
              textLine1="+966 5780 21911"
            />
          </a>
        </Col>
        <Col xs={3} sm={2} className="contact__info">
          <a href="tel:+966576520029" aria-label="Call +966 5765 20029">
            <ContactInfoBox
              icon={ContactInfoIcon2}
              textLine1="+966 5765 20029"
            />
          </a>
        </Col>
      </Row>

      {/* Second row of 3 contact information items */}
      <Row center="xs">
        <Col xs={12} sm={4} className="contact__info">
          <a href="mailto:sales@kafaah.net" aria-label="Email sales@kafaah.net">
            <ContactInfoBox
              icon={ContactInfoIcon3}
              textLine1="sales@kafaah.net"
            />
          </a>
        </Col>
        <Col xs={12} sm={4} className="contact__info">
          <a
            href="https://www.google.com/maps?q=Riyadh,Saudi+Arabia"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="View location on Google Maps"
          >
            <ContactInfoBox
              icon={ContactInfoIcon3}
              textLine1="Riyadh, Saudi Arabia"
            />
          </a>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default contactInfo;
